import {
    AlertDialog,
    AlertDialogAction,
    AlertDialogCancel,
    AlertDialogContent,
    AlertDialogDescription,
    AlertDialogFooter,
    AlertDialogHeader,
    AlertDialogTitle,
} from '@/components/ui/alert-dialog'
import { useSessionsStore } from '../stores/sessions-store'

interface DeleteSessionDialogProps {
    onConfirm: () => void
}

export function DeleteSessionDialog({ onConfirm }: DeleteSessionDialogProps) {
    const deleteDialog = useSessionsStore((s) => s.deleteDialog)
    const setDeleteDialogOpen = useSessionsStore((s) => s.setDeleteDialogOpen)

    const handleCancel = () => {
        setDeleteDialogOpen(false)
    }

    const handleConfirm = () => {
        onConfirm()
        setDeleteDialogOpen(false)
    }

    return (
        <AlertDialog open={deleteDialog.isOpen} onOpenChange={(open) => !open && handleCancel()}>
            <AlertDialogContent>
                <AlertDialogHeader>
                    <AlertDialogTitle>确认删除会话</AlertDialogTitle>
                    <AlertDialogDescription>
                        您确定要删除这个会话吗？此操作无法撤销。
                    </AlertDialogDescription>
                </AlertDialogHeader>
                <AlertDialogFooter>
                    <AlertDialogCancel onClick={handleCancel}>取消</AlertDialogCancel>
                    <AlertDialogAction onClick={handleConfirm}>确认删除</AlertDialogAction>
                </AlertDialogFooter>
            </AlertDialogContent>
        </AlertDialog>
    )
}
